import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconBracketsCurly32(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={32}
            height={32}
            className={customClassName}
            name="IconBracketsCurly32"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M12.036 27a1 1 0 0 0-.06-2h-.003l-.055-.002a2.3 2.3 0 0 1-1.096-.396C10.271 24.22 9.5 23.312 9.5 21c0-1.432-.316-2.568-.844-3.456a4.94 4.94 0 0 0-1.491-1.58C8.418 15.1 9.5 13.567 9.5 11c0-2.237.764-3.156 1.331-3.561a2.45 2.45 0 0 1 1.12-.434L12.008 7h.004A1 1 0 0 0 12 5v1l-.001-1h-.033a2 2 0 0 0-.218.015 4.45 4.45 0 0 0-2.08.796C8.487 6.656 7.5 8.237 7.5 11c0 2.095-.913 3.02-1.74 3.484A4.2 4.2 0 0 1 4.004 15h-.031L4 16l-.028-1a1 1 0 0 0 .04 2L4 16l.012 1h.029l.1.003a3.9 3.9 0 0 1 1.634.453c.429.233.847.58 1.162 1.11.316.531.563 1.302.563 2.434 0 2.816.979 4.408 2.179 5.244a4.3 4.3 0 0 0 2.103.75 3 3 0 0 0 .22.006h.033L12 26zm7.928 0a1 1 0 0 1 .06-2h.003l.055-.002a2.3 2.3 0 0 0 1.096-.396c.55-.383 1.322-1.29 1.322-3.602 0-1.432.316-2.568.844-3.456a4.94 4.94 0 0 1 1.491-1.58C23.582 15.1 22.5 13.567 22.5 11c0-2.237-.764-3.156-1.331-3.561a2.45 2.45 0 0 0-1.12-.434L19.992 7h-.004A1 1 0 0 1 20 5v1c0-1 0-1 .002-1h.032a2 2 0 0 1 .218.015c.134.014.314.04.527.09.422.101.986.302 1.552.706C23.514 6.656 24.5 8.237 24.5 11c0 2.095.913 3.02 1.74 3.484a4.2 4.2 0 0 0 1.757.515l.019.001h.011L28 16l-.012 1h-.029l-.1.003a3.9 3.9 0 0 0-1.634.453c-.429.233-.847.58-1.163 1.11-.315.531-.562 1.302-.562 2.434 0 2.816-.979 4.408-2.179 5.244a4.3 4.3 0 0 1-2.103.75 3 3 0 0 1-.213.006zL20 26zM28 16l-.011 1a1 1 0 0 0 .04-2z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconBracketsCurly32);
